// The Settings tab (both pages): how solid the panels are, and whether an orbit drag locks the pointer.
// Kept in this browser; the page starts with them.
import type { Controls } from './controls.ts';

const KEY = 'cloudview.settings.v1';
interface Settings { paneAlpha: number; lockOrbit: boolean }
const DEFAULTS: Settings = { paneAlpha: 0.45, lockOrbit: true };

function load(): Settings {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || 'null');
    return {
      paneAlpha: typeof s?.paneAlpha === 'number' && s.paneAlpha >= 0 && s.paneAlpha <= 1 ? s.paneAlpha : DEFAULTS.paneAlpha,
      lockOrbit: typeof s?.lockOrbit === 'boolean' ? s.lockOrbit : DEFAULTS.lockOrbit,
    };
  } catch { return { ...DEFAULTS }; }   // storage blocked, or not JSON
}

/** Apply the kept settings and wire the tab's inputs (those on this page). */
export function initSettings(ctl: Controls) {
  const $ = <T extends HTMLElement>(id: string) => document.getElementById(id) as T | null;
  const alpha = $<HTMLInputElement>('setalpha'), alphaV = $('setalphav'), lock = $<HTMLInputElement>('setlock'), reset = $('setreset');
  let s = load();
  const apply = () => {
    // the panels' background and, a little more solid, their tabs' (the stylesheet's own: 0.45 and 0.65)
    const st = document.documentElement.style;
    st.setProperty('--pane-bg', `rgb(19 21 26 / ${s.paneAlpha})`);
    st.setProperty('--tabs-bg', `rgb(11 12 15 / ${Math.min(1, s.paneAlpha + 0.2)})`);
    ctl.lockOrbit = s.lockOrbit;
    if (alpha) alpha.value = String(s.paneAlpha);
    if (alphaV) alphaV.textContent = `${Math.round(s.paneAlpha * 100)} %`;
    if (lock) lock.checked = s.lockOrbit;
  };
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* storage blocked */ } };
  apply();
  if (alpha) alpha.oninput = () => { s.paneAlpha = Number(alpha.value); apply(); save(); };
  if (lock) lock.onchange = () => { s.lockOrbit = lock.checked; apply(); save(); };
  if (reset) reset.onclick = () => { s = { ...DEFAULTS }; apply(); save(); };
}
